export const reducerTypes = {
  RENDER_SCREEN: "render-screen",
  TOGGLE_NEWSLETTER: "toggle-newsletter",
  UPDATE_MULTISESSION_TOKEN: "update-multisession-token",
} as const;
